import {EventDispatcher} from '@megaphonenpm/mputils/src/EventDispatcher.js';
import {LoadWebPollsTask} from './LoadWebPollsTask.js';
import {CHANGE, COMPLETE} from '@megaphonenpm/mputils/src/constants.js';
import {union} from '@megaphonenpm/mputils/src/utils.js';

/**
 * Provides a centralized location through which to load all Web Polls for the current playlist in
 * the supplied dataStore.
 */
export class WebPollsDataManager extends EventDispatcher {

  constructor (dataStore, webPollAppStateSynchronizer) {
    super();

    this.dataStore = dataStore;
    this.webPollAppStateSynchronizer = webPollAppStateSynchronizer;
  }

  /**
   * Updates the dataStore's Web Polls and dispatches the following events:
   *   1) CHANGE: One or more of the newly loaded Web Polls have changed (updated content or new results)
   *   2) COMPLETE: All Web Polls have finished loading
   */
  refresh () {
    let loadWebPollsTask = new LoadWebPollsTask(this.dataStore);
    loadWebPollsTask.on(COMPLETE, () => {
      if (loadWebPollsTask.contentChangedPollIDs.length > 0
          || loadWebPollsTask.resultsChangedPollIDs.length > 0) {

        // If the current scene is a webpoll scene, and that scene's underlying webpoll changed
        // during this refresh, then update the AppState's webpollScene.
        let allChangedPollIDs = union(loadWebPollsTask.contentChangedPollIDs, loadWebPollsTask.resultsChangedPollIDs);
        if (allChangedPollIDs.has(this.webPollAppStateSynchronizer.appState.getCurrentSceneSrcID())) {
          this.webPollAppStateSynchronizer.syncCurrentWebPoll();
        }

        this.dispatchEvent(CHANGE, {
          contentChangedPollIDs: loadWebPollsTask.contentChangedPollIDs.slice(),
          resultsChangedPollIDs: loadWebPollsTask.resultsChangedPollIDs.slice()
        });
      }

      this.dispatchEvent(COMPLETE);
    });
    loadWebPollsTask.start();
  }
}
